import {
  SET_STRATEGIES,
  SET_COMPARE_STRATEGIES,
  ADD_TO_COMPARE,
  REMOVE_FROM_COMPARE,
  CLEAR_STRATEGIES,
  RECIEVE_TREATMENTGROUPS,
  SET_TREATMENTGROUP_ID
} from "./types";

export const initialState = {
  strategies: [],
  treatmentGroups: [],
  selectedTreatmentGroupValue: -1,
  compareStrategyIds: [], //The selected strategies, only ids
  compareStrategiesData: {
    names:[],
    weedCategory:[],
    dosage:[],
    comments:[],
    effects:[],
    usageAreas:[],
    waitingDays:[]
  } // Fetched in the compare page. Full strategies
};

export const strategies = (state = initialState, action) => {
  switch (action.type) {
    case SET_STRATEGIES:
      return {
        ...state,
        strategies: action.payload,
        openStrategies: [],
        expandCrops: [],
        compareStrategyIds: []
      };
    case SET_COMPARE_STRATEGIES:
      return {
        ...state,
        compareStrategiesData: action.payload
      };
    case ADD_TO_COMPARE:
      return {
        ...state,
        compareStrategyIds: state.compareStrategyIds.concat(action.payload)
      };
    case REMOVE_FROM_COMPARE:
      return {
        ...state,
        compareStrategyIds: state.compareStrategyIds.filter(c => action.payload != c)
      };
      case RECIEVE_TREATMENTGROUPS:
        return {
          ...state,
          treatmentGroups: action.payload
        };
        case SET_TREATMENTGROUP_ID:
          return {
            ...state,
            selectedTreatmentGroupValue: action.payload
          };
     case CLEAR_STRATEGIES:
        return initialState;
    default:
      return state;
  }
};

export default strategies;
